import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import decksReducer from "./decksReducer";
import StyleReducer from "./StyleReducer";
import QuestionReducer from "./questionsReducer";
import DeviceReducer from "./DeviceReducer";

const SASPApp =  combineReducers({
  auth: AuthReducer,
  style: StyleReducer,
  decks: decksReducer,
  question: QuestionReducer,
  device: DeviceReducer
});

export default SASPApp;